import React, { useRef } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Image,
  Box,
  Divider,
  Card,
  CardBody,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Slideshow from "./Slideshow";

const origWebsite = [
  "/images/uiux_images/old1.png",
  "/images/uiux_images/old2.png",
  "/images/uiux_images/old3.png",
];

export default function Sakura() {
  return (
    <Flex pt="10vh" justifyContent={"center"} flexDir={"column"}>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/sakura mockup2.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
        <Text variant={"tinyHeader"} my="1rem">
          Sakura Online Ordering
        </Text>
        <Text variant={"subtitle"} w="50%" textAlign={"center"} color="grey">
          An important aspect of online web applications is responsiveness to
          various platforms, accessibility to different users, and aesthetic
          quality. In this assignment, I chose a webpage to analyze, improve,
          and ultimately redesign according to the principles above.
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/sakura icons.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
      </Flex>
      <Flex
        pt="2rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#65ABB0"
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          color="white"
          py="1rem"
        >
          1. The problem
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          display={"flex"}
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            The online ordering page of Sakura, a Japanese restaurant in
            Providence, RI, is simple yet difficult to navigate. In terms of
            usability, the customer must navigate through several pages in order
            to view menu items, add them to their cart, and checkout. Because
            the color palette is mostly black and gray, the hierarchy of
            elements becomes difficult to discern and the customer loses sense
            of what is most important. Moreover, the lack of images and colors
            leads room for confusion as to what the customer is ordering or
            looking for, especially if they are unfamiliar with the names of
            food items.
          </Text>
        </Box>
        <Slideshow pics={origWebsite} />
      </Flex>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          py="1rem"
          color="black"
        >
          2. Improvements
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="#D9D9D9"
          p="1rem"
          w="50%"
          display={"flex"}
          my="1rem"
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            My solution was to integrate more pops of color and create a clear
            hierarchy and sense of grouping between like elements. I placed a
            categorizer on the left hand side, which has drop down buttons that
            allow customers to quickly filter their options. Moreover, I
            incorporated images of each menu item and made a clear “Add to Cart”
            button, as well as the cart icon on the top right corner. Overall,
            this made the ordering website and process more succinct as
            customers could view the most important pieces of information all in
            one place.
          </Text>
        </Box>
      </Flex>
      <Flex
        py="2rem"
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#B74343"
      >
        <Text variant={"subUIHeader"} color="white" py="1rem">
          3. Redesign
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          display={"flex"}
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            Most importantly, my redesigned website is responsive to desktop,
            tablet, and mobile devices. As the size of the screen shrinks, the
            website adapts smoothly to the platform’s new dimensions, allowing
            users to seamlessly view the ordering page anywhere they go.
          </Text>
        </Box>
      </Flex>
      <Flex
        py="2rem"
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "70%" }}
          src={"/images/uiux_images/sakura mockup3.png"}
          borderRadius={"1rem"}
        />
        <Button
          variant="solidLink"
          w={"20%"}
          bgGradient={"linear(130deg, #D0F384, #A6E6FB)"}
          _hover={{
            color: "grey",
            textDecoration: "none",
            transition: "all 0.4s",
            bg: "transparent",
            border: "2px solid #D9D9D9",
          }}
          onClick={() => {
            window.open(
              "https://sleepysloth123.github.io/SAKURAWEBPAGE/?",
              "_blank" // <- open in a new window.
            );
          }}
        >
          STATIC PREVIEW
        </Button>

        <Box
          borderRadius={".5rem"}
          bg="#D9D9D9"
          p="1rem"
          w="50%"
          display={"flex"}
          my="2rem"
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            Redesigning the Sakura ordering page helped me to think through
            design principles of usability, memorability, efficiency,
            learnability, and the conceptual model. I learned how to make
            webpages respond to various screen dimensions, as well as which
            layouts were more common and fitting for desktop vs tablet vs mobile
            devices.
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
}
